import { Component, OnInit,Pipe, PipeTransform } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-joinvc-meeting',
  templateUrl: './joinvc-meeting.component.html',
  styleUrls: ['./joinvc-meeting.component.scss']
})
export class JoinvcMeetingComponent implements OnInit {
  @Pipe({ name: 'safe' })
  joinVCForm: FormGroup;
  result:any; 
  pdata:any; 
  pat_id:any;
  cons_id:any;
  joinData:any; 

  //patient details
  d_name :any
  d_gender :any //gender and age in years and days    
  d_blood_group :any
  d_marital_status :any
  d_email :any
  d_phone :any

//consulation details
  cons_date_time :any //cons date and time
  cons_type :any  

//vital signs
  pulse_rate :any
  blood_pressure :any
  temperature :any
  glucose :any
  hemoglobin :any
  ecg_monitor :any
  height :any
  weight :any

  //other info
  complaints_data:any
  symptoms_data:any
  diseases_data:any
  allergys_data:any
  under_bp_medication :any
  under_sugar_medication :any

  btnstate: boolean=true;
  firstName:any;

  vcData:any; 
  urlSafe: SafeResourceUrl;
  consult_id;
  patient_id;

  

  constructor(private sanitizer:DomSanitizer,private fb: FormBuilder,public router:Router,private serviceService: ServiceService, private route: ActivatedRoute) { }

  ngOnInit(): void {

    this.firstName=localStorage.getItem('firstName');
    this.joinVCForm = this.fb.group({
      meeting_id:['', Validators.required]
        
    });

    //console.log('vc page');    
    this.route.paramMap.subscribe((params) => {
      this.cons_id = params.get('cons_id')!;
      this.pat_id = params.get('pat_id')!;
    
    });
    console.log('consult id :'+this.cons_id)
    console.log('patient id:'+this.pat_id)
    this.getDoctorDetail(this.pat_id, this.cons_id);
  }
    getDoctorDetail(p_id, c_id){
    this.serviceService.GetConsultation_Doctor_Detail(p_id, c_id)
    .subscribe((data) => {
      this.result=data;          
      
      //patient details
      this.d_name = this.result[0].d_name;
      this.d_gender = this.result[0].d_gender; 
      this.d_email = this.result[0].d_email;
      this.d_phone = this.result[0].d_phone;
      
      //consulation details
      this.cons_date_time = this.result[0].cons_date_time; //cons date and time
      this.cons_type = this.result[0].cons_type;         

      //vital signs
      this.pulse_rate = this.result[0].pulse_rate;
      this.blood_pressure = this.result[0].blood_pressure;
      this.temperature = this.result[0].temperature;
      this.glucose = this.result[0].glucose;
      this.hemoglobin = this.result[0].hemoglobin;
      this.ecg_monitor = this.result[0].ecg_monitor;
      this.height = this.result[0].height;
      this.weight = this.result[0].weight;

      //other info
      this.complaints_data=this.result[0].complaintslist;
      this.symptoms_data=this.result[0].symptomslist;
      this.diseases_data=this.result[0].diseaseslist;
      this.allergys_data=this.result[0].allergylist;
      this.under_bp_medication = this.result[0].under_bp_medication;
      this.under_sugar_medication = this.result[0].under_sugar_medication;

    });         


  }
 

  joinMeeting()
  { 
     
     this.btnstate = false;   
   
   
   var passdata={
     meetingId:this.joinVCForm.value.meeting_id,
     joineeName:this.firstName
 }

 //alert("data pass: " +JSON.stringify(passdata));  
    this.serviceService.joinMeeting_Online(passdata)
   .subscribe((data) => {
   this.joinData=data;
   console.log("join url: " +JSON.stringify(this.joinData.joinMeetingUrl));
   this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.joinData.joinMeetingUrl);    

   });

 }


}
